
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "/workspace/home/service/resources/modern/react/src/components/modals/Webform2FaModal.jsx";
              export default OriginalModule.default;
              export * from "/workspace/home/service/resources/modern/react/src/components/modals/Webform2FaModal.jsx";